export default __webpack_public_path__ + "static/HomeBG2-d6bf35ab0ab34d3acebabd22bf8efa79.png";